import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  static targets = ["query", "row", "selection", "count", "empty"];
  static values = { selectedLabel: String };

  connect() {
    this.activeType = "";
    this.updateCount();
  }

  reset() {
    this.selectionTargets.forEach((input) => { input.disabled = true; });
    this.rowTargets.forEach((row) => {
      row.setAttribute("aria-checked", "false");
    });
    this.updateCount();
  }

  filter() {
    const query = this.queryTarget.value.trim().toLowerCase();
    let visibleCount = 0;
    this.rowTargets.forEach((row) => {
      row.hidden = !(row.dataset.search.includes(query) && (!this.activeType || row.dataset.type === this.activeType));
      if (!row.hidden) visibleCount += 1;
    });
    this.emptyTarget.hidden = visibleCount > 0;
  }

  selectFilter(event) {
    this.activeType = event.currentTarget.dataset.filter;
    this.element.querySelectorAll("button[data-filter]").forEach((button) => {
      button.setAttribute("aria-pressed", (button === event.currentTarget).toString());
    });
    this.filter();
  }

  toggle(event) {
    event.preventDefault();
    const row = event.currentTarget;
    if (row.getAttribute("aria-disabled") === "true") return;

    const input = row.querySelector("input[data-link-in-bio-editor-target-picker-target='selection']");
    const selected = row.getAttribute("aria-checked") !== "true";
    const section = this.element.closest("[data-editor-section]");
    const limit = Number(this.element.closest("[data-link-in-bio-editor-max-items-value]")?.dataset.linkInBioEditorMaxItemsValue);
    const existing = section?.querySelectorAll("[data-item-list] > [data-editor-item]").length || 0;
    const count = this.selectionTargets.filter((candidate) => !candidate.disabled).length;
    if (selected && limit && existing + count >= limit) {
      this.dispatch("limit", { bubbles: true });
      return;
    }
    input.disabled = !selected;
    row.setAttribute("aria-checked", selected.toString());
    row.focus({ preventScroll: true });
    this.updateCount();
  }

  updateCount() {
    const count = this.selectionTargets.filter((input) => !input.disabled).length;
    this.countTarget.textContent = `${count} ${this.selectedLabelValue}`;
    this.dispatch("selection", { detail: { count } });
  }
}
